(function() {
  function init() {
    var sections = document.querySelectorAll('.bd-button-group');
    sections.forEach(function(section) {
      if (section.dataset.bdButtonGroupInit === 'true') return;
      section.dataset.bdButtonGroupInit = 'true';
      section.addEventListener('click', function(e) {
        var btn = e.target.closest('.bd-button-group__btn--scroll');
        if (!btn) return;
        var scrollClass = btn.getAttribute('data-scroll-to-class');
        var el = null;

        if (scrollClass) {
          var classSelector = scrollClass.replace(/^\./, '');
          if (classSelector) {
            el = document.querySelector('.' + CSS.escape(classSelector));
          }
        } else {
          var id = btn.getAttribute('data-scroll-to') || (btn.getAttribute('href') || '').replace(/^#/, '');
          if (!id) return;
          el = document.getElementById(id);
        }

        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
